module.exports = __webpack_public_path__ + "img/lz4.0beb61f5.png";